const TRANSLATION = {
  buyModal: {
    afterFree: 'आपके निःशुल्क परीक्षण के बाद',
    btn: 'मुफ्त में आजमाएं',
    freeTrial: '3-दिवसीय नि:शुल्क परीक्षण',
    monthLabel: 'महीना',
    selectLabel: 'एक योजना चुनें',
    title: 'सदस्यता योजना',
    yearLabel: 'वर्ष',
  },
  contact: {
    block1:
      'अनुकूलन, प्रश्न या सुझाव के लिए कृपया हमसे contact@noam.tools पर संपर्क करें। हम तुरंत जवाब देंगे.',
    block2: '★★★★★ पर Google Apps एक्सटेंशन स्टोर पर हमें रेटिंग देकर हमारा समर्थन करें।',
    block3: 'इस एक्सटेंशन को साझा करके दूसरों की सहायता करें:',
    title: 'हमसे संपर्क करें',
  },
  help: {
    AquickOverviewOfNoam: 'नोआम का एक त्वरित अवलोकन',
    ChatPDF: 'चैट पीडीएफ',
    ChatPDF2: 'चैटपीडीएफ',
    FavoritesManagement: 'पसंदीदा प्रबंधन',
    Fixedplugin: 'फिक्स्ड प्लगइन',
    Focusing: 'ध्यान केंद्रित',
    Free: 'मुक्त',
    FreeTrialBenefits: 'निःशुल्क परीक्षण लाभ',
    GoWithWikipedia: 'विकिपीडिया के साथ चलें',
    GoWithYouTube: 'यूट्यूब के साथ जाओ',
    HoverTranslation: 'होवर अनुवाद',
    Howtouse: 'का उपयोग कैसे करें',
    ImageTranslation: 'छवि अनुवाद',
    InstantTranslation: 'तुरंत अनुवाद',
    Membership: 'सदस्यता',
    NoamHelp: 'नोआम आपको अनुवाद और सारांश प्रस्तुत करने में मदद करता है',
    PDFparallelTranslation: 'पीडीएफ समानांतर अनुवाद',
    ParallelTranslation: 'समानांतर अनुवाद',
    SkipAllSteps: 'सभी चरण छोड़ें',
    Summary: 'सारांश',
    Translation: 'अनुवाद',
    TryItForFree: 'इसका उपयोग मुफ्त में करें',
    Video: 'वीडियो',
    VideoSummary: 'वीडियो सारांश',
    VideoTranslation: 'वीडियो अनुवाद',
    WebSummary: 'वेब सारांश',
    WordSelectionTranslation: 'शब्द चयन अनुवाद',
    benefits: 'हमारे पास लाभ आपका इंतजार कर रहे हैं!',
    dayFree: '3-दिवसीय नि:शुल्क परीक्षण',
    done: 'हो गया',
    next: 'अगला',
    pin: 'आसान पहुंच के लिए पिन नोम～～',
    planIsNotExist: 'योजना उपलब्ध नहीं है',
    startWiki: 'आइए विकिमीडिया से शुरुआत करें!',
    startYoutube: 'आइए यूट्यूब से शुरुआत करें!',
    try: 'कोशिश करके देखो',
    tryNow: 'इसे अभी आज़माएं!',
  },
  home: {
    PDFTranslate: {
      desc: 'द्विभाषी अनुवाद + चैट पीडीएफ',
      sub1: {
        desc: 'द्विभाषी पढ़ने से आप मूल पाठ और अनुवाद की साथ-साथ तुलना कर सकते हैं, जिससे पढ़ने की दक्षता में सुधार होता है।',
        title: 'द्विभाषी पढ़ना',
      },
      sub2: {
        desc: 'एआई विश्लेषण और सारांश देता है, और पीडीएफ सामग्री के आधार पर आपके प्रश्नों का उत्तर दे सकता है।',
        title: 'चैट पीडीएफ',
      },
      sub3: {
        desc: 'अधिक सटीकता और दक्षता के लिए एआई-संचालित पीडीएफ अनुवाद।',
        title: 'सटीकता और दक्षता',
      },
      title: 'पीडीएफ अनुवाद',
    },
    aiAssistant: {
      desc: 'वेब अनुवाद को अधिक स्मार्ट और अधिक सुविधाजनक बनाना',
      panel1: {
        desc: 'द्विभाषी क्रॉस-रेफरेंसिंग अनुवाद आपको मूल पाठ की तुलना अनुवाद से करने में मदद करते हैं ताकि आप बेहतर समझ सकें और अपनी पढ़ने की दक्षता में सुधार कर सकें।',
        title: 'द्विभाषी अनुवाद',
      },
      panel2: {
        left: {
          desc: 'वेब पेज ब्राउज़ करते समय, अनुवाद देखने के लिए उस सामग्री पर होवर करें जिसका आपको अनुवाद करना है।',
          title: 'होवर अनुवाद',
        },
        right: {
          desc: 'वेब पेज ब्राउज़ करते समय, अनुवाद देखने के लिए उस टेक्स्ट का चयन करें जिसका आप अनुवाद करना चाहते हैं।',
          title: 'पाठ चयन अनुवाद',
        },
      },
      panel3: {
        one: {
          desc: 'बेहतर अनुभव के लिए कभी भी, कहीं भी वेब पेजों और वीडियो सामग्री का अनुवाद और सारांश करें!',
          title: 'बिंदु और क्लिक करें',
        },
        three: {
          desc: 'एआई-संचालित बड़ा भाषा मॉडल बेहतर पढ़ने के अनुभव के लिए अनुवाद सटीकता और स्थिरता सुनिश्चित करता है।',
          title: 'ऐ संचालित',
        },
        two: {
          desc: 'बहु-भाषा पूर्ण कवरेज, द्विभाषी बाधा-मुक्त पढ़ना, एक-क्लिक अनुवाद - अंतर का अनुभव करें!',
          title: 'अधिक व्यापक और सुविधाजनक',
        },
      },
      panel4: {
        tab1: {
          desc: 'आपका दक्षता विशेषज्ञ - ChatGPT का उपयोग करके, नोआम आपका समय बचाने के लिए YouTube वीडियो सामग्री का अनुवाद और सारांश करता है!',
          key: 'वीडियो',
          title: 'वीडियो अनुवाद एवं सारांश',
        },
        tab2: {
          desc: 'वेब ब्राउज़ करते समय छवियों का अनुवाद करने के लिए क्लिक करें।',
          key: 'छवि',
          title: 'छवि अनुवाद',
        },
        tab3: {
          desc: 'वेब पेजों से तुरंत महत्वपूर्ण जानकारी निकालता है और एक सारांश प्रदान करता है, जिससे आपकी पढ़ने की क्षमता बढ़ती है।',
          key: 'वेब',
          title: 'वेब अनुवाद एवं सारांश',
        },
        tag1: 'सरल',
        tag2: 'कुशल',
        tag3: 'समझने में आसान',
      },
      title: 'एआई सहायक',
    },
    getStart: 'शुरू हो जाओ',
    getStartedForFree: 'निःशुल्क आरंभ करें',
    howItWork: {
      desc: 'नोआम उपयोगकर्ताओं को अंतर-भाषा वेब पेज अनुवाद और सारांश, पीडीएफ और छवि अनुवाद, वीडियो अनुवाद और सारांश के लिए एक बुद्धिमान अनुभव प्रदान करने के लिए एआई मॉडल को एकीकृत करता है।',
      title: 'यह काम किस प्रकार करता है',
    },
    lastBlock: { desc: 'बेहतर पढ़ने के अनुभव के लिए बेहतर एआई अनुवाद' },
    top: {
      desc: 'नोआम एक मुफ़्त एआई ब्राउज़र एक्सटेंशन है जो आपको वेब पेजों, वीडियो और पीडीएफ सामग्री का अनुवाद और सारांशित करने में मदद करता है।\\n नोआम से जुड़ें और जादू का अनुभव करें!',
      title1: 'एक जादू',
      title2: 'एक क्लिक',
    },
    userReviews: {
      desc: 'Chrome वेब स्टोर पर पाँच सितारा समीक्षाएँ',
      title: 'उपयोगकर्ता समीक्षाएँ',
    },
  },
  installTips: {
    btn: 'अब इसे आजमाओ',
    text: 'अधिक सुविधाओं को अनलॉक करने के लिए "नोम ब्राउज़र प्लगइन" इंस्टॉल करें! वेब क्रॉस-रेफ़रेंसिंग,\\n वेब वीडियो सारांश, और बहुत कुछ!',
  },
  locale: {
    af: 'अफ्रीकी',
    am: 'अम्हारिक्',
    ar: 'अरबी',
    as: 'असमिया',
    auto: 'ऑटो का पता लगाने',
    az: 'आज़रबाइजानी',
    ba: 'बशख़िर',
    bg: 'बल्गेरियाई',
    bn: 'बांग्ला',
    bo: 'तिब्बती',
    bs: 'बोस्नियाई',
    ca: 'कातालान',
    cs: 'चेक',
    cy: 'वेल्श',
    da: 'डेनिश',
    de: 'जर्मन',
    dsb: 'निचला सोरबियन',
    dv: 'दिवेही',
    el: 'यूनानी',
    en: 'अंग्रेज़ी',
    es: 'स्पैनिश',
    et: 'एस्तोनियावासी',
    eu: 'बस्क',
    fa: 'फ़ारसी',
    fi: 'फिनिश',
    fil: 'filipino',
    fj: 'फिजी',
    fr: 'फ़्रेंच',
    frCA: 'फ़्रेंच (कनाडा)',
    ga: 'आयरिश',
    gl: 'गैलिशियन्',
    gom: 'कोंकणी',
    gu: 'गुजराती',
    ha: 'होउसा',
    he: 'यहूदी',
    hi: 'हिंदी',
    hr: 'क्रोएशियाई',
    hsb: 'ऊपरी सोरबियन',
    ht: 'हाईटियन क्रियोल',
    hu: 'हंगेरी',
    hy: 'अर्मेनियाई',
    id: 'इन्डोनेशियाई',
    ig: 'ईग्बो',
    ikt: 'इनुइनाक्टुन',
    is: 'आइसलैंड का',
    it: 'इतालवी',
    iu: 'इनूकीटूत्',
    iuLatn: 'इनुक्टिटुट (लैटिन)',
    ja: 'जापानी',
    ka: 'जॉर्जीयन्',
    kk: 'कजाख',
    km: 'खमेर',
    kmr: 'कुर्दिश (उत्तरी)',
    kn: 'कन्नडा',
    ko: 'कोरियाई',
    ku: 'कुर्दिश (मध्य)',
    ky: 'किरगिज़',
    ln: 'लिंगाला',
    lo: 'लाओ',
    lt: 'लिथुआनियाई',
    lug: 'गंडा',
    lv: 'लात्वीयावासी',
    lzh: 'चीनी (साहित्यिक)',
    mai: 'मैथिली',
    mg: 'मालागासी',
    mi: 'माओरी',
    mk: 'मेसीडोनियन',
    ml: 'मलयालम',
    mnCyrl: 'मंगोलियाई (सिरिलिक)',
    mnMong: 'मंगोलियाई (पारंपरिक)',
    mr: 'मराठी',
    ms: 'मलायी',
    mt: 'मोलतिज़',
    mww: 'हमोंग डॉ',
    my: 'म्यांमार (बर्मी)',
    nb: 'नार्वेजियन',
    ne: 'नेपाली',
    nl: 'डच',
    noSearchLang: 'भाषा समर्थित नहीं है',
    nso: 'सेसोथो सा लेबोआ',
    nya: 'न्यानजा',
    or: 'उड़िया',
    otq: 'क्वेरेटारो ओटोमी',
    pa: 'पंजाबी',
    pl: 'पोलिश',
    placeholder: 'खोज',
    prs: 'दारी',
    ps: 'पश्तो',
    pt: 'पुर्तगाली (ब्राजील)',
    ptPT: 'पुर्तगाली (पुर्तगाल)',
    ro: 'रोमानियाई',
    ru: 'रूसी',
    run: 'रुन्दी',
    rw: 'किन्यारवाण्डा',
    sd: 'सिंधी',
    si: 'सिंहली',
    sk: 'स्लोवाक',
    sl: 'स्लोवेनियाई',
    sm: 'सामोन',
    sn: 'सोणा',
    so: 'सोमाली',
    sq: 'अल्बानियन',
    srCyrl: 'सर्बियाई (सिरिलिक)',
    srLatn: 'सर्बियाई (लैटिन)',
    st: 'सेसोथो',
    sv: 'स्वीडिश',
    sw: 'swahili',
    ta: 'तामिल',
    te: 'तेलुगू',
    th: 'थाई',
    ti: 'तिग्रिन्या',
    tk: 'तुक्रमेन',
    tlhLatn: 'क्लिंगन (लैटिन)',
    tlhPiqd: 'क्लिंगन (pIqaD)',
    tn: 'सेत्सवाना',
    to: 'टोंगन',
    tr: 'तुर्की',
    tt: 'टाटर',
    ty: 'ताहितियन',
    ug: 'उईघुर',
    uk: 'यूक्रेनी',
    ur: 'उर्दू',
    uz: 'उज़्बेक (लैटिन)',
    vi: 'वियतनामी',
    xh: 'षोसा',
    yo: 'योरूबा',
    yua: 'युकाटेक माया',
    yue: 'कैंटोनीज़ (पारंपरिक)',
    zh: 'चीनी',
    zhHans: 'सरलीकृत चीनी',
    zhHant: 'चीनी पारंपरिक',
    zu: 'ज़ुलु',
  },
  login: {
    and: 'और',
    btn: 'Google से लॉग इन करें',
    btn1: 'अभी लॉगिन करें',
    desc: 'अधिक अनुभवों को अनलॉक करने के लिए लॉग इन करें',
    policy: 'गोपनीयता नीति',
    terms: 'उपयोग की शर्तें',
    tips: 'साइन अप करके, मैं इससे सहमत हूं',
    title: 'नोआम में आपका स्वागत है',
  },
  pageFooter: {
    follow: { facebook: 'फेसबुक', title: 'अनुसरण करना', twitter: 'ट्विटर' },
    legal: { policy: 'गोपनीयता नीति', terms: 'सेवा की शर्तें', title: 'कानूनी' },
    product: {
      image: 'छवि अनुवाद',
      pdf: 'पीडीएफ अनुवाद',
      title: 'उत्पादों',
      video: 'वीडियो अनुवाद एवं सारांश',
      web: 'वेब अनुवाद और सारांश',
    },
    resources: { title: 'संसाधन' },
  },
  pageHeader: {
    contact: 'संपर्क',
    help: 'मदद',
    logout: 'लॉग आउट',
    logoutSucc: 'बाहर आ गये।',
    pricing: 'मूल्य निर्धारण',
    settings: 'सेटिंग्स',
    signUp: 'लॉग इन करें',
  },
  pdf: {
    autoDetect: 'ऑटो का पता लगाने',
    cancelBtn: 'रद्द करना',
    cancelUpload: 'रद्द करना',
    chatPdf: {
      Search: 'खोज',
      cancel: 'रद्द करना',
      chatTitle: 'नोआम में आपका स्वागत है! यहां आपके पीडीएफ का सारांश दिया गया है:',
      clear: 'स्पष्ट',
      clearContent:
        'इससे एक नई बातचीत शुरू होगी. वर्तमान वार्तालाप सहेजा नहीं जाएगा. क्या आपको यकीन है?',
      clearDialogTitle: 'कृपया पुष्टि करें',
      clearSucc: 'साफ़ किया गया',
      copy: 'प्रतिलिपि',
      copySucc: 'कॉपी किया गया',
      delete: 'मिटाना',
      deleteCancel: 'रद्द करना',
      deleteContent:
        'एक बार डिलीट होने के बाद इस पीडीएफ को पुनर्प्राप्त नहीं किया जा सकता है। क्या आपको यकीन है?',
      deleteOk: 'मिटाना',
      deleteSuccess: 'हटाए गए',
      deleteTitle: 'हटाने की पुष्टि करें',
      expand: 'गिर जाना',
      historyTitle: 'इतिहास',
      listError:
        'पठन सूची लोड करने में विफल. कृपया बाद में पुनः प्रयास करें, या सहायता से संपर्क करें।',
      loading: 'लोड हो रहा है...',
      noDataDesc: 'अभी तक कोई इतिहास नहीं.',
      noMore: 'कोई और सामग्री नहीं.',
      placeholder: 'इस पीडीएफ के बारे में कुछ भी पूछें',
      summaryTitle: 'आपको इन प्रश्नों में रुचि हो सकती है:',
    },
    collectionEmpty: 'आपका संग्रह खाली है.',
    collectionTab: 'टिप्पणियाँ',
    dataLoading: 'लोड हो रहा है...',
    dialogContent: 'क्या आप वाकई इसे हटाना चाहते हैं?',
    dialogTitle: 'कृपया पुष्टि करें',
    download: {
      both: 'द्विभाषिक',
      btn: 'बचाना',
      cancel: 'इस विंडो को बंद करने से पीडीएफ डाउनलोड रद्द हो जाएगा। आप आप रद्द करना चाहते हैं?',
      desc: 'डिवाइस में सहेजें: अनुवादों को छवियों के रूप में डाउनलोड करता है; सहेजें और प्रिंट करें: कॉपी समर्थन के साथ मूल प्रारूप में अनुवाद डाउनलोड करता है।',
      download: 'डाउनलोड करना',
      downloadMsg1: 'पीडीएफ अनुवाद प्रगति:',
      downloadMsg2: 'अनुमानित शेष समय:',
      downloadSucc: 'पीडीएफ तैयार है! सहेजने के लिए क्लिक करें.',
      downloadTip:
        'पीडीएफ डाउनलोड हो रहा है. डाउनलोड त्रुटियों से बचने के लिए इस विंडो को बंद न करें।',
      error: 'सहेजने में विफल. इसके बजाय मुद्रण का प्रयास करें.',
      fileName: 'फ़ाइल का नाम:',
      fileType: 'फ़ाइल प्रकार:',
      loading: 'सहेजा जा रहा है...',
      loading2: 'लोड हो रहा है...',
      minute: 'मिनट...',
      msg1: 'इस दस्तावेज़ में कुछ अनुवाद मूल पाठ से अधिक लंबे हैं, और डाउनलोड की गई फ़ाइल में ओवरलैप हो सकते हैं। हम वेबपेज पर पढ़ने की सलाह देते हैं।',
      msg2: '1. अनुवाद अभी पूरा नहीं हुआ है. कृपया अनुवाद समाप्त होने के बाद डाउनलोड करें।',
      msg3: '2. कुछ अनुवाद बहुत लंबे हैं. टेक्स्ट ओवरलैप से बचने के लिए वेबपेज पर पढ़ें।',
      msg4: 'अनुवाद कार्य प्रगति पर हैं. कृपया पूरा होने के बाद पुनः प्रयास करें।',
      progress: 'पीडीएफ का अनुवाद. प्रगति: {{प्रगति}}, अनुमानित समय शेष: {{मिनट}} मिनट...',
      save: 'ERROR: [Save to Device]',
      savePrint: 'सहेजें और प्रिंट करें',
      success: 'डाउनलोड',
      trans: 'केवल अनुवाद',
      transContinue: 'अनुवाद करना जारी रखें',
    },
    downloadBtn: 'डाउनलोड करना',
    dragTipModal: {
      black: 'अंतरिक्ष',
      leftKey: 'बायां बटन',
      ok: 'समझ गया',
      press: 'प्रेस',
      tips: 'खींचने और देखने के लिए.',
    },
    entry: 'पीडीएफ़',
    fileErrMsg: 'फ़ाइल पढ़ना विफल रहा. कृपया बाद में पुनः प्रयास करें, या सहायता से संपर्क करें।',
    fileMsg: 'वर्तमान फ़ाइल आकार:',
    fileMsg2: 'कृपया 300एमबी से छोटी फ़ाइल अपलोड करें।',
    freeBannerBtn: 'उन्नत करना',
    freeBannerTips: 'निःशुल्क पीडीएफ अनुवाद की सीमा पूरी हो गई',
    guide: {
      placeholder: 'पीडीएफ लिंक यहां पेस्ट करें',
      start: 'अनुवाद करना प्रारंभ करें',
      text1: 'द्विभाषी पढ़ना',
      text2:
        'मूल पाठ और अनुवाद की साथ-साथ तुलना करने के लिए द्विभाषी रूप से पढ़ें, जिससे आपकी दक्षता में सुधार होगा।',
      text3: 'अपने पीडीएफ के साथ चैट करें',
      text4:
        'एआई-संचालित विश्लेषण और सारांश। अपने पीडीएफ के बारे में प्रश्न पूछें, और तुरंत उत्तर प्राप्त करें।',
      text5: 'सटीक एवं कुशल',
      text6: 'अधिक सटीकता और दक्षता के लिए एआई-संचालित पीडीएफ अनुवाद।',
      title1: 'द्विभाषी अनुवाद',
      title2: 'अपने पीडीएफ के साथ चैट करें',
      toast: 'कृपया .pdf से समाप्त होने वाला एक वैध ऑनलाइन पीडीएफ लिंक दर्ज करें',
    },
    hasTransTask: 'अनुवाद कार्य प्रगति पर है. कृपया प्रतीक्षा करें।',
    hoverTrans: 'होवर-टू-अनुवाद पैराग्राफ',
    initial: 'पीडीएफ का अनुवाद करें',
    installText: 'रोजमर्रा के अनुवादों के लिए आपका वन-स्टॉप समाधान।',
    installText2: 'कृपया पहले एक्सटेंशन इंस्टॉल करें',
    installTips:
      'और भी अधिक पीडीएफ अनुवादों और सहज वेबसाइट अनुवादों के लिए एक्सटेंशन इंस्टॉल करें:',
    kw: 'प्रधान',
    link: 'जोड़ना',
    listError:
      'पीडीएफ़ लोड करने में विफल. कृपया बाद में पुनः प्रयास करें, या सहायता से संपर्क करें।',
    memoTotalCount: 'कुल 1 आइटम',
    new: 'नई फ़ाइल',
    noId: 'फ़ाइल आईडी नहीं मिली.',
    notPdf: 'केवल पीडीएफ फ़ाइलें.',
    okBtn: 'मिटाना',
    okBtn2: 'समझ गया',
    original: 'मूल',
    parallel: 'समानांतर',
    parseErrDialogContent:
      'इस पीडीएफ लिंक का सीधे अनुवाद नहीं किया जा सकता। कृपया पीडीएफ डाउनलोड करें और अनुवाद के लिए इसे अपलोड करें।',
    parseErrTips: 'फ़ाइल को पार्स करने में विफल',
    parseFileToast:
      'फ़ाइल को पार्स करने में विफल. कृपया बाद में पुनः प्रयास करें, या सहायता से संपर्क करें।',
    pdfLoading: 'पार्सिंग...',
    searchPlaceholder: 'खोज',
    selectTrans: 'अनुवाद करने के लिए टेक्स्ट का चयन करें',
    shareBtn: 'शेयर करना',
    shareBtnText1: 'शेयर लिंक जनरेट करें',
    shareBtnText2: 'साझा सामग्री अद्यतन करें',
    shareModal: {
      cancel: 'रद्द करना',
      copy: 'प्रतिलिपि',
      copySucc: 'लिंक कॉपी किया गया',
      custom: 'अनुकूलित करें:',
      errMsg:
        'चयनित सामग्री का अभी तक पूरी तरह से अनुवाद नहीं किया गया है। कृपया साझा करने से पहले अनुवाद करें.',
      gen: 'शेयर करना',
      modify: 'संपादन करना',
      notSupport: 'यह भाषा वर्तमान में समर्थित नहीं है.',
      page: 'पृष्ठों',
      pageNuErr: 'कृपया एक वैध पृष्ठ संख्या दर्ज करें.',
      range: 'दायरा:',
      remain: 'शेष',
      remain1: 'कुल अनुमानित समय:',
      search: 'खोज',
      settings: 'शेयर सेटिंग्स:',
      shareSetting: 'सेटिंग्स साझा करें',
      shareText: 'शेयर करना',
      shareTips: 'अनुवादित पीडीएफ लिंक अपने दोस्तों के साथ साझा करें:',
      sourceLang: 'से:',
      target: 'को:',
      text1: 'सेटिंग्स साझा करें',
      text2: 'शेयर लिंक जनरेट करें',
      totalPage: 'कुल 1 पेज',
      trans: 'अनुवाद',
      translateTips:
        'युक्ति: यदि अनुवाद में कुछ समय लग रहा है, तो आप इस विंडो को बंद कर सकते हैं और बाद में साझा कर सकते हैं।',
      translating: 'पीडीएफ का अनुवाद किया जा रहा है...',
      update: 'अपडेट शेयर लिंक',
    },
    shareMsg1: 'लिंक साझा करें जनरेट हुआ.',
    shareMsg2: 'साझा सामग्री अद्यतन की गई.',
    shareMsg3:
      'शेयर लिंक जनरेट करने में विफल. कृपया बाद में पुनः प्रयास करें, या सहायता से संपर्क करें।',
    shareMsg4:
      'साझा सामग्री अपडेट करने में विफल. कृपया बाद में पुनः प्रयास करें, या सहायता से संपर्क करें।',
    shareTips: 'आपका पीडीएफ अनुवाद तैयार है! इसे अपने दोस्तों के साथ साझा करें।',
    start: 'अपना नि: शुल्क परीक्षण शुरू करो',
    thumbnail: 'विषयसूची',
    toast1: 'पीडीएफ लोड हो रहा है. कृपया बाद में पुन: प्रयास करें।',
    toast2: 'पीडीएफ सामग्री बहुत बड़ी है. डायलॉग फिलहाल असमर्थित है.',
    toast3: 'डाउनलोड हो रहा है. कृपया डाउनलोड समाप्त होने के बाद पुनः प्रयास करें।',
    toolbar: { Adjust: 'समायोजित करना', autoFit: 'स्वत: फ़िट' },
    trans: 'अनुवाद',
    transSucc: 'अनुवाद सफल!',
    unLoginToast: 'इस विशेष सुविधा का प्रयोग करने के लिए लॉग इन करें।',
    uploadBtn: 'अपलोड करें',
    uploadErr: 'फ़ाइल अपलोड विफल रहा. कृपया बाद में पुनः प्रयास करें, या सहायता से संपर्क करें।',
    uploadMsg1: 'अपनी फ़ाइल को यहां खींचें और छोड़ें.',
    uploadMsg2: 'समर्थित फ़ाइल प्रकार: पीडीएफ |  अधिकतम फ़ाइल आकार: 100एमबी',
    uploadMsg3: 'फ़ाइलों को चुनने या खींचने और छोड़ने के लिए यहां क्लिक करें।',
    uploading: 'अपलोड हो रहा है',
    uploadingMsg: 'अपलोड हो रहा है. कृपया प्रतीक्षा करें।',
    uploadingMsg1: 'फ़ाइल अपलोड हो रही है. कृपया बाद में पुन: प्रयास करें।',
    uploadingMsg2: 'एक फ़ाइल वर्तमान में परिवर्तित की जा रही है. कृपया बाद में पुन: प्रयास करें।',
    uploadingMsg3:
      'रूपांतरण प्रगति अनुरोध विफल रहा. कृपया बाद में पुनः प्रयास करें, या सहायता से संपर्क करें।',
    uploadingMsg4:
      'नोआम स्थानीय फ़ाइलों तक नहीं पहुंच सकता. कृपया अनुवाद के लिए मैन्युअल रूप से एक पीडीएफ अपलोड करें।',
    uploadingMsg5:
      'फ़ाइल URL पुनर्प्राप्त करने में विफल. कृपया बाद में पुनः प्रयास करें, या सहायता से संपर्क करें।',
    video: 'वीडियो',
    vipBannerBtn: 'उन्नत करना',
    vipBannerTips: 'आप इस महीने के लिए अपनी पीडीएफ अनुवाद सीमा तक पहुंच गए हैं।',
    webTrans: 'पूर्ण क्रॉस-रेफरेंस',
  },
  pricing: {
    FAQ: 'अक्सर पूछे जाने वाले प्रश्न',
    FQAObj: {
      a1: 'हां, नोआम एक निःशुल्क योजना प्रदान करता है जिसका आप तुरंत उपयोग कर सकते हैं।',
      a2: 'हम तीन सदस्यता योजनाएं पेश करते हैं: प्रो, प्रो+ और एंटरप्राइज। आप मासिक या वार्षिक भुगतान करना चुन सकते हैं। वार्षिक बिलिंग महत्वपूर्ण बचत प्रदान करती है।',
      a3: 'दोनों योजनाओं पर सभी सुविधाएँ उपलब्ध हैं। मुख्य अंतर लागत है: वार्षिक सदस्यता की लागत कुल मिलाकर कम है। मासिक सदस्यताओं का बिल हर महीने लिया जाता है, जबकि वार्षिक योजनाओं का बिल साल में एक बार लिया जाता है।',
      a4: 'आप अपनी खाता सेटिंग में किसी भी समय अपनी सदस्यता रद्द कर सकते हैं।',
      q1: 'क्या कोई निःशुल्क योजना है?',
      q2: 'कौन सी मूल्य निर्धारण योजनाएँ और भुगतान विकल्प उपलब्ध हैं?',
      q3: 'मासिक बनाम वार्षिक सदस्यता लेने के बीच क्या अंतर है?',
      q4: 'मैं अपना सबस्क्रिप्शन कैसे रद्द करूं?',
    },
    around: 'आस-पास',
    billedMonthly: 'मासिक बिल भेजा गया',
    billedYearly: 'वार्षिक बिल किया गया',
    day: 'दिन',
    desc: 'योजनाओं की तुलना करें और सर्वश्रेष्ठ चुनें',
    detailedCompare: 'योजनाओं की तुलना करें',
    discount: '20% की छूट',
    enterprise: {
      benefit1: 'प्राथमिकता ग्राहक सहायता',
      benefit2: 'एकाधिक उपयोगकर्ता',
      benefit3: 'अनुरूप समाधान',
      benefit5: 'समर्पित खाता प्रबंधक',
      btn: 'हमसे संपर्क करें',
      recommendText: 'कस्टम योजनाएं（≥3人）',
      talkToUs: 'संपर्क में रहो',
    },
    free: {
      benefit1: 'प्रति दिन 100 बार त्वरित अनुवाद',
      benefit2: 'वेबसाइट अनुवाद एवं सारांश',
      benefit3: '30 छवि अनुवाद',
      benefit4: 'वीडियो अनुवाद एवं सारांश',
      benefit5: '10 पीडीएफ अनुवाद',
      benefit6: '5,000 टोकन',
      btn: 'मुफ्त में आजमाएं',
      recommendText: 'मुफ्त परीक्षण',
    },
    imageTranslation: 'छवि अनुवाद',
    month: 'महीना',
    monthly: 'महीने के',
    pageTitle: 'मूल्य निर्धारण',
    pdf: {
      chat: 'पीडीएफ चैट क्वेरीज़',
      maxPage: 'अधिकतम. प्रति पीडीएफ पेज',
      translation: 'पीडीएफ अनुवाद',
    },
    preMonth: 'प्रति महीने',
    pro: {
      benefit1: 'प्राथमिकता ग्राहक सहायता',
      benefit2: '1,000,000 टोकन/माह',
      benefit3: 'वेबसाइट अनुवाद एवं सारांश',
      benefit4: '200 छवि अनुवाद',
      benefit5: 'वीडियो अनुवाद एवं सारांश',
      benefit6: '200 पीडीएफ अनुवाद',
      btn: 'शुरू हो जाओ',
      recommendText: 'सबसे लोकप्रिय',
    },
    proPlus: {
      benefit1: 'प्राथमिकता ग्राहक सहायता',
      benefit2: '3,000,000 टोकन/माह',
      benefit3: 'वेबसाइट अनुवाद एवं सारांश',
      benefit4: '500 छवि अनुवाद',
      benefit5: 'वीडियो अनुवाद एवं सारांश',
      benefit6: '500 पीडीएफ अनुवाद',
      recommendText: 'सबसे अच्छा मूल्य',
    },
    video: { summary: 'वीडियो सारांश', translation: 'वीडियो अनुवाद' },
    web: {
      contrastiveTranslation: 'द्विभाषी अनुवाद',
      dictionaryTranslation: 'चयन अनुवाद',
      hoverTranslation: 'होवर अनुवाद',
      instantTranslation: 'तुरंत अनुवाद',
      summary: 'वेब पेज सारांश',
    },
    yearly: 'सालाना',
  },
  privacy: {
    block1:
      'नोआम ("नोआम," "हम," "हमारा," या "हम") आपकी गोपनीयता का सम्मान करता है और आपसे या आपके बारे में प्राप्त किसी भी जानकारी की सुरक्षा के लिए प्रतिबद्ध है। यह गोपनीयता नीति हमारी वेबसाइट, एप्लिकेशन और सेवाओं (सामूहिक रूप से, "सेवाएं") के आपके उपयोग से व्यक्तिगत जानकारी के संग्रह या उपयोग के संबंध में हमारी प्रथाओं का वर्णन करती है। यह गोपनीयता नीति उस सामग्री पर लागू नहीं होती है जिसे हम अपने व्यावसायिक उत्पाद ग्राहकों की ओर से संभालते हैं, जैसे कि हमारा एपीआई। इस डेटा का उपयोग हमारे ग्राहक समझौते के अधीन है, जो इन उत्पादों तक पहुंच और उपयोग को कवर करता है।',
    block10:
      'हम ऑनलाइन और ऑफलाइन व्यक्तिगत जानकारी को हानि, दुरुपयोग और अनधिकृत पहुंच, प्रकटीकरण, परिवर्तन या शत्रुतापूर्ण कृत्यों से बचाने के लिए व्यावसायिक रूप से उचित तकनीकी, प्रशासनिक और संगठनात्मक उपाय लागू करते हैं। हालाँकि, कोई भी इंटरनेट या ईमेल ट्रांसमिशन पूर्ण सुरक्षा या सटीकता की गारंटी नहीं दे सकता है। विशेष रूप से, हमें या हमारी ओर से भेजे गए ईमेल सुरक्षित नहीं हो सकते हैं। इसलिए, आपको यह तय करते समय विशेष रूप से सावधान रहना चाहिए कि सेवा या ईमेल के माध्यम से हमें कौन सी जानकारी भेजनी है। इसके अतिरिक्त, हम सेवा या तृतीय पक्ष वेबसाइटों की सुरक्षा सेटिंग्स या सुरक्षा उपायों में गोपनीयता सेटिंग्स या सुरक्षा उपायों में किसी भी बाधा के लिए ज़िम्मेदार नहीं हैं। हम आपकी व्यक्तिगत जानकारी को तब तक बनाए रखेंगे जब तक हमें आपको सेवाएं प्रदान करने या अन्य वैध व्यावसायिक उद्देश्यों, जैसे विवादों को हल करने, सुरक्षा और सुरक्षा कारणों, या हमारे कानूनी दायित्वों का अनुपालन करने के लिए आवश्यक होगा। व्यक्तिगत जानकारी को हम कितने समय तक बनाए रखेंगे, यह कई कारकों पर निर्भर करेगा, जैसे जानकारी की मात्रा, प्रकृति, संवेदनशीलता, अनधिकृत उपयोग या प्रकटीकरण के संभावित जोखिम, वे उद्देश्य जिनके लिए हम जानकारी संसाधित करते हैं, और अन्य कानूनी रूप से बाध्यकारी विचार।',
    block11:
      'हम इस गोपनीयता नीति को समय-समय पर अद्यतन कर सकते हैं। जब हम ऐसा करेंगे, तो हम इस पृष्ठ पर एक अद्यतन संस्करण पोस्ट करेंगे, जब तक कि लागू कानून द्वारा अन्यथा आवश्यक न हो।',
    block12:
      'यदि इस गोपनीयता नीति के बारे में आपके कोई अनुत्तरित प्रश्न या चिंताएं हैं, तो कृपया हमारी ग्राहक सेवा से संपर्क करें। ईमेल:',
    block2: 'हम आपसे संबंधित निम्नलिखित व्यक्तिगत जानकारी ("व्यक्तिगत जानकारी") एकत्र करते हैं:',
    block3:
      'आपके द्वारा प्रदान की गई जानकारी: जब आप हमारी सेवाओं का उपयोग करने या हमारे साथ संवाद करने के लिए एक खाता बनाते हैं, तो हम निम्नानुसार व्यक्तिगत जानकारी एकत्र करते हैं:',
    block4:
      'सेवाओं के आपके उपयोग से स्वचालित रूप से प्राप्त होने वाली व्यक्तिगत जानकारी: जब आप सेवाओं तक पहुँचते हैं, उपयोग करते हैं या उनके साथ इंटरैक्ट करते हैं, तो हमें आपकी पहुँच, उपयोग या इंटरैक्शन के बारे में निम्नलिखित जानकारी प्राप्त होती है ("तकनीकी जानकारी"):',
    block5: 'हम निम्नलिखित उद्देश्यों के लिए व्यक्तिगत जानकारी का उपयोग कर सकते हैं:',
    block6:
      'सारांश या गैर-पहचान वाली जानकारी: हम पहचान उद्देश्यों के लिए इसके पुन: उपयोग को रोकने के लिए व्यक्तिगत जानकारी को एकत्रित या गैर-पहचान कर सकते हैं और ऐसी जानकारी का उपयोग हमारी सेवाओं की प्रभावशीलता का विश्लेषण करने, हमारी सेवाओं में सुधार करने और सुविधाओं को जोड़ने, अनुसंधान करने और इसी तरह के उद्देश्यों के लिए कर सकते हैं। . इसके अतिरिक्त, हम अपने सेवा उपयोगकर्ताओं के सामान्य व्यवहार और विशेषताओं का विश्लेषण कर सकते हैं और एकत्रित जानकारी को तीसरे पक्ष के साथ साझा कर सकते हैं, ऐसी एकत्रित जानकारी प्रकाशित कर सकते हैं, या इसे आम तौर पर उपलब्ध करा सकते हैं। हम सेवाओं के माध्यम से, कुकीज़ के माध्यम से और इस गोपनीयता नीति में वर्णित अन्य माध्यमों से समग्र जानकारी एकत्र कर सकते हैं। हम अज्ञात या गैर-पहचान वाले रूप में पहचान रहित जानकारी को बनाए रखेंगे और उपयोग करेंगे, और जब तक कानून द्वारा आवश्यक न हो, हम ऐसी जानकारी को फिर से पहचानने का प्रयास नहीं करेंगे।',
    block7:
      'कुछ मामलों में, जब तक कानून द्वारा आवश्यक न हो, हम आपको बिना किसी पूर्व सूचना के आपकी व्यक्तिगत जानकारी तीसरे पक्ष को प्रदान कर सकते हैं:',
    block8:
      'आपकी भौगोलिक स्थिति के आधार पर, यूरोपीय आर्थिक क्षेत्र, यूनाइटेड किंगडम और विश्व स्तर पर व्यक्तियों के पास उनकी व्यक्तिगत जानकारी के संबंध में कुछ वैधानिक अधिकार हो सकते हैं। उदाहरण के लिए, आपके पास इसका अधिकार हो सकता है:',
    block9:
      'सेवा में सोशल मीडिया सेवाओं ("थर्ड पार्टी वेबसाइट्स") सहित नोआम द्वारा संचालित या नियंत्रित नहीं की जाने वाली अन्य वेबसाइटों के लिंक शामिल हो सकते हैं। आपके द्वारा तृतीय पक्ष वेबसाइटों के साथ साझा की जाने वाली जानकारी तृतीय पक्ष वेबसाइटों की विशिष्ट गोपनीयता नीतियों और सेवा की शर्तों द्वारा शासित होगी, न कि इस गोपनीयता नीति द्वारा। हम ये लिंक सुविधा के लिए प्रदान करते हैं और इन वेबसाइटों का हमारा समर्थन या समीक्षा नहीं करते हैं। कृपया उनकी गोपनीयता नीतियों और शर्तों के बारे में जानकारी के लिए सीधे तीसरे पक्ष की वेबसाइटों से संपर्क करें।',
    subBlock1:
      'खाता जानकारी: जब आप हमारे प्लेटफ़ॉर्म पर एक खाता बनाते हैं, तो हम आपके खाते से संबंधित जानकारी एकत्र करते हैं, जिसमें आपका नाम, संपर्क जानकारी, खाता क्रेडेंशियल, भुगतान कार्ड की जानकारी और लेनदेन इतिहास ("खाता जानकारी") शामिल है।',
    subBlock10: 'सेवाएँ प्रदान करना, प्रबंधन करना, रखरखाव करना और/या उनका विश्लेषण करना;',
    subBlock11: 'आपके साथ संचार करना;',
    subBlock12: 'नए उत्पादों और सेवाओं का विकास करना;',
    subBlock13:
      'धोखाधड़ी, आपराधिक गतिविधि, या हमारी सेवाओं के दुरुपयोग को रोकना, और हमारे आईटी सिस्टम, वास्तुकला और नेटवर्क की सुरक्षा की रक्षा करना;',
    subBlock14: 'व्यापार हस्तांतरण का संचालन करना;',
    subBlock15:
      'कानूनी दायित्वों और कानूनी कार्यवाही का अनुपालन करना, हमारे अधिकारों, गोपनीयता, सुरक्षा, या संपत्ति, साथ ही हमारे सहयोगियों, आपके या अन्य तृतीय पक्षों की रक्षा करना।',
    subBlock16:
      'आपूर्तिकर्ता और सेवा प्रदाता: व्यावसायिक परिचालन आवश्यकताओं को पूरा करने और कुछ सेवाओं और कार्यों को करने में हमारी सहायता करने के लिए, हम आपूर्तिकर्ताओं और सेवा प्रदाताओं को व्यक्तिगत जानकारी प्रदान कर सकते हैं, जिसमें होस्टिंग सेवा प्रदाता, क्लाउड सेवा प्रदाता और अन्य सूचना प्रौद्योगिकी सेवा प्रदाता, ईमेल संचार सॉफ्टवेयर शामिल हैं। , और वेब एनालिटिक्स सेवा प्रदाता, आदि। ये भागीदार हमारे लिए अपने कर्तव्यों का पालन करते हुए केवल हमारे निर्देश पर व्यक्तिगत जानकारी तक पहुंच, प्रक्रिया या भंडारण करेंगे।',
    subBlock17:
      'व्यवसाय स्थानांतरण: यदि हम रणनीतिक लेनदेन, पुनर्गठन, दिवालियापन, दिवालियापन अधिग्रहण, या किसी अन्य प्रदाता को सेवा संक्रमण (सामूहिक रूप से, "लेनदेन") में संलग्न होते हैं, तो आपकी व्यक्तिगत जानकारी और अन्य जानकारी लेनदेन समकक्षों और लेनदेन में सहायता करने वाले अन्य दलों के साथ साझा की जा सकती है। उचित परिश्रम के दौरान और लेनदेन के हिस्से के रूप में अन्य परिसंपत्तियों के साथ एक उत्तराधिकारी या संबद्ध कंपनी को हस्तांतरित कर दिया गया।',
    subBlock18:
      'कानूनी आवश्यकताएँ: हम आपकी व्यक्तिगत जानकारी सरकारी अधिकारियों, उद्योग साथियों, या अन्य तृतीय पक्षों के साथ साझा कर सकते हैं, जिसमें हमारी सेवाओं के साथ आपकी बातचीत की जानकारी भी शामिल है, (1) यदि कानून द्वारा आवश्यक हो या यदि हमें लगता है कि कानूनी दायित्वों का पालन करने के लिए ऐसी कार्रवाई आवश्यक है; (2) हमारे अधिकारों या संपत्ति की रक्षा और बचाव करना; (3) यदि हम एकतरफा यह निर्धारित करते हैं कि हमारी शर्तों, नीतियों या कानूनों का उल्लंघन हुआ है; (4) धोखाधड़ी या अन्य अवैध गतिविधियों का पता लगाना या उन्हें रोकना; (5) हमारे उत्पादों, कर्मचारियों, या उपयोगकर्ताओं, या सार्वजनिक सुरक्षा, सुरक्षा, अखंडता की रक्षा के लिए; या (vi) कानूनी दायित्व से बचाव के लिए।',
    subBlock19:
      'अपनी व्यक्तिगत जानकारी और इसे कैसे संसाधित किया जाता है इसके बारे में जानकारी तक पहुंचें।',
    subBlock2:
      'उपयोगकर्ता सामग्री: जब आप हमारी सेवाओं का उपयोग करते हैं, तो हम आपके इनपुट, फ़ाइल अपलोड, या हमें प्रदान की गई प्रतिक्रिया ("सामग्री") से व्यक्तिगत जानकारी एकत्र करते हैं।',
    subBlock20: 'हमारे रिकॉर्ड से अपनी व्यक्तिगत जानकारी हटाने का अनुरोध करें।',
    subBlock21: 'अपनी व्यक्तिगत जानकारी को सही या अद्यतन करें।',
    subBlock22: 'अपनी व्यक्तिगत जानकारी किसी तीसरे पक्ष (डेटा पोर्टेबिलिटी) को स्थानांतरित करें।',
    subBlock23: 'हम आपकी व्यक्तिगत जानकारी को कैसे संसाधित करते हैं उसे सीमित करें।',
    subBlock24:
      'अपनी सहमति वापस लें—जहां हम प्रसंस्करण के लिए कानूनी आधार के रूप में सहमति पर भरोसा करते हैं, आप किसी भी समय अपनी सहमति वापस ले सकते हैं।',
    subBlock25: 'इस पर आपत्ति है कि हम आपकी व्यक्तिगत जानकारी को कैसे संसाधित करते हैं।',
    subBlock26: 'हमारी सेवाओं में सुधार करना और अनुसंधान करना;',
    subBlock3:
      'संचार जानकारी: यदि आप हमें संदेश भेजते हैं, तो हम आपका नाम, संपर्क जानकारी और आपके संदेशों की सामग्री ("संचार जानकारी") एकत्र करेंगे।',
    subBlock4:
      'सोशल मीडिया जानकारी: हमारे पास इंस्टाग्राम, फेसबुक, मीडियम, ट्विटर, यूट्यूब और लिंक्डइन जैसी सोशल मीडिया वेबसाइटों पर पेज हैं। जब आप हमारे सोशल मीडिया पेजों के साथ बातचीत करते हैं, तो हम आपकी व्यक्तिगत जानकारी एकत्र करते हैं जिसे आप हमें प्रदान करना चाहते हैं, जैसे कि आपका संपर्क विवरण ("सामाजिक जानकारी")। इसके अतिरिक्त, हमारे सोशल मीडिया पेजों को होस्ट करने वाली कंपनियां हमें हमारी सोशल मीडिया गतिविधियों के बारे में समग्र जानकारी और विश्लेषण प्रदान कर सकती हैं।',
    subBlock5:
      'लॉग डेटा: हमारी सेवाओं का उपयोग करते समय आपके ब्राउज़र द्वारा स्वचालित रूप से भेजी गई जानकारी। लॉग डेटा में आपका इंटरनेट प्रोटोकॉल (आईपी) पता, ब्राउज़र प्रकार और सेटिंग्स, आपके अनुरोधों की तारीख और समय और आप हमारी वेबसाइट के साथ कैसे इंटरैक्ट करते हैं, शामिल हैं।',
    subBlock6:
      'उपयोग डेटा: हम सेवा के आपके उपयोग के बारे में स्वचालित रूप से जानकारी एकत्र कर सकते हैं, जैसे कि आप किस प्रकार की सामग्री देखते हैं या उसके साथ बातचीत करते हैं, आपके द्वारा उपयोग की जाने वाली सुविधाएँ, आपके द्वारा की जाने वाली गतिविधियाँ, साथ ही आपका समय क्षेत्र, देश, दिनांक और समय। पहुंच, उपयोगकर्ता एजेंट और संस्करण, कंप्यूटर या मोबाइल डिवाइस प्रकार, और आपका कंप्यूटर कनेक्शन।',
    subBlock7:
      'डिवाइस जानकारी: इसमें डिवाइस का नाम, ऑपरेटिंग सिस्टम, डिवाइस पहचानकर्ता और आपके द्वारा उपयोग किया जा रहा ब्राउज़र शामिल है। एकत्र की गई जानकारी आपके द्वारा उपयोग किए जा रहे डिवाइस के प्रकार और उसकी सेटिंग्स पर निर्भर हो सकती है।',
    subBlock8:
      'कुकीज़: हम अपनी सेवाओं को संचालित और प्रबंधित करने और आपके अनुभव को बेहतर बनाने के लिए कुकीज़ का उपयोग करते हैं। "कुकी" वह जानकारी है जो आपके द्वारा देखी गई वेबसाइट द्वारा आपके ब्राउज़र पर भेजी जाती है। आप अपने ब्राउज़र को सभी कुकीज़ को स्वीकार करने, सभी कुकीज़ को अस्वीकार करने, या कुकी प्रदान किए जाने पर आपको सूचित करने के लिए सेट कर सकते हैं ताकि आप यह तय कर सकें कि हर बार इसे स्वीकार करना है या नहीं। हालाँकि, कुकीज़ को अस्वीकार करने से आपको वेबसाइट का उपयोग करने से रोका जा सकता है या वेबसाइट के कुछ क्षेत्रों या सुविधाओं के प्रदर्शन या कार्यक्षमता पर नकारात्मक प्रभाव पड़ सकता है। कुकीज़ के बारे में अधिक जानकारी के लिए, कृपया कुकीज़ के बारे में सब कुछ पर जाएँ।',
    subBlock9:
      'एनालिटिक्स: हम विभिन्न ऑनलाइन एनालिटिक्स उत्पादों का उपयोग कर सकते हैं जो कुकीज़ का उपयोग करके हमें यह विश्लेषण करने में मदद करते हैं कि उपयोगकर्ता हमारी सेवाओं का उपयोग कैसे करते हैं और सेवाओं का उपयोग करते समय आपके अनुभव को बेहतर बनाते हैं।',
    subTitle1: 'व्यक्तिगत जानकारी जो हम एकत्र करते हैं',
    subTitle2: 'हम व्यक्तिगत जानकारी का उपयोग कैसे करते हैं',
    subTitle3: 'व्यक्तिगत जानकारी का प्रकटीकरण',
    subTitle4: 'आपके हक',
    subTitle5: 'अन्य वेब साइटों के लिंक',
    subTitle6: 'सूचना की सुरक्षा और प्रतिधारण',
    subTitle7: 'गोपनीयता नीति में संशोधन',
    subTitle8: 'हम से कैसे संपर्क करें',
    title: 'गोपनीयता नीति',
    updateTime: 'अपडेट किया गया: 15 मार्च, 2024',
  },
  privacyCollectionPanel: {
    acceptBtn: 'सभी स्वीकृत',
    text: 'आपके अनुभव को बेहतर बनाने के लिए, हम सामग्री और सेवाओं को निजीकृत करने के लिए कुकीज़ का उपयोग करते हैं।',
    title: 'यह वेबसाइट कुकीज़ का उपयोग करती है',
  },
  slogen: 'सबसे आसान एआई सहायक',
  stripe: {
    contact: 'किसी भी प्रश्न के लिए हमसे contact@noam.tools पर संपर्क करें!',
    fail: {
      btn: 'पुन: प्रयास करें',
      text1: 'हम आपका भुगतान संसाधित नहीं कर सके.',
      text2: 'अपना कनेक्शन जांचें और पुनः प्रयास करें।',
      title: 'भुगतान विफल रही',
    },
    succ: {
      btn: 'चल दर',
      text1: 'नोआम में आपका स्वागत है,',
      text2: 'आएँ शुरू करें!',
      title: 'बधाई हो',
    },
  },
  terms: {
    block1: 'नोआम का उपयोग करने के लिए धन्यवाद!',
    block10:
      '(ए) फीस और बिलिंग। आप लागू मूल्य निर्धारण पृष्ठ पर मूल्य निर्धारण और शर्तों के अनुसार या हमारे बीच लिखित सहमति के अनुसार सभी शुल्क ("फीस") का भुगतान करेंगे। हम मूल्य निर्धारण त्रुटियों या गलतियों को ठीक करने का अधिकार सुरक्षित रखते हैं, भले ही हमने चालान जारी किया हो या भुगतान प्राप्त किया हो। आप वैध और अधिकृत भुगतान विधि सहित पूर्ण और सटीक बिलिंग जानकारी प्रदान करेंगे। हम सहमति के अनुसार आवधिक आधार पर आपकी भुगतान विधि से शुल्क लेंगे, लेकिन हम बिलिंग तिथि को उचित रूप से बदल सकते हैं। आप अपनी भुगतान विधि से शुल्क लेने के लिए Noam, उसके सहयोगियों और तृतीय-पक्ष भुगतान प्रोसेसर को अधिकृत करते हैं। यदि आपका भुगतान विफल हो जाता है, तो हम आपको लिखित सूचना देंगे और भुगतान प्राप्त होने तक सेवा तक पहुंच निलंबित कर सकते हैं। इस अनुबंध में अन्यथा निर्दिष्ट को छोड़कर, भुगतान गैर-वापसी योग्य हैं।',
    block11:
      '(बी) कर। जब तक अन्यथा न कहा जाए, शुल्क में कोई भी संघीय, राज्य, स्थानीय और विदेशी कर, शुल्क और समान मूल्यांकन ("कर") शामिल नहीं हैं। हमारी शुद्ध आय पर आधारित करों को छोड़कर, जिसके लिए हम आपको चालान देंगे, आप अपनी खरीदारी से जुड़े सभी करों के लिए जिम्मेदार हैं। आप ऐसे करों का तुरंत भुगतान करने और हमें कानूनी रूप से वैध गोपनीयता विवरण प्रदान करने और ऐसे डेटा को संभालने के लिए आवश्यक सहमति प्राप्त करने के लिए सहमत हैं, और आप हमें आश्वासन देते हैं कि आप ऐसे डेटा को लागू कानून के अनुसार संभालेंगे।',
    block12:
      '(सी) मूल्य परिवर्तन। हम आपके खाते और/या हमारी वेबसाइट के माध्यम से आपको सूचित करके अपनी कीमतें बदल सकते हैं। मूल्य वृद्धि पोस्टिंग के तुरंत बाद प्रभावी होगी। परिवर्तन की प्रभावी तिथि के बाद कोई भी मूल्य परिवर्तन आपके खाते के शुल्क पर लागू होगा।',
    block13:
      '(डी) विवाद और अतिदेय भुगतान। यदि आप किसी शुल्क या कर पर विवाद करना चाहते हैं, तो कृपया चालान तिथि के तीस (30) दिनों के भीतर contact@noam.tools से संपर्क करें।',
    block14:
      '(ई) निःशुल्क उपयोग। आप मुफ़्त क्रेडिट प्राप्त करने के लिए एकाधिक खाते नहीं बना सकते हैं। यदि हम यह निर्धारित करते हैं कि आप नि:शुल्क क्रेडिट का उपयोग अच्छे विश्वास के साथ नहीं कर रहे हैं, तो हम आपसे मानक शुल्क ले सकते हैं या सेवा तक पहुंच प्रदान करना बंद कर सकते हैं।',
    block15:
      '(ए) गोपनीयता। आपके पास नोआम की गोपनीय जानकारी तक पहुंच हो सकती है। आप सेवा का उपयोग करने के उद्देश्य से केवल इन शर्तों के तहत अनुमति के अनुसार गोपनीय जानकारी का उपयोग कर सकते हैं। आप किसी भी तीसरे पक्ष को गोपनीय जानकारी का खुलासा नहीं कर सकते हैं, और आप गोपनीय जानकारी की रक्षा उसी तरीके से करेंगे, जो कम से कम उचित देखभाल के साथ, अपनी समान गोपनीय जानकारी की रक्षा करने से कम सुरक्षात्मक नहीं होगी। गोपनीय जानकारी गैर-सार्वजनिक जानकारी है जिसे नोम द्वारा गोपनीय के रूप में निर्दिष्ट किया गया है या जिसे सॉफ़्टवेयर, विनिर्देशों और अन्य गैर-सार्वजनिक व्यावसायिक जानकारी सहित परिस्थितियों में उचित रूप से गोपनीय माना जाना चाहिए। गोपनीय जानकारी में वह जानकारी शामिल नहीं है जो: (1) आपकी गलती के बिना आम तौर पर जनता के लिए उपलब्ध हो जाती है; (2) इन शर्तों के तहत इसे प्राप्त करने से पहले यह आपके पास गोपनीयता की किसी बाध्यता के बिना था; (3) बिना किसी गोपनीयता दायित्व के किसी तीसरे पक्ष द्वारा आपको कानूनी रूप से प्रकट किया गया है; या (4) गोपनीय जानकारी का उपयोग किए बिना आपके द्वारा स्वतंत्र रूप से विकसित किया गया है। यदि कानून, अदालत या अन्य सरकारी आदेश द्वारा आवश्यक हो तो आप गोपनीय जानकारी का खुलासा कर सकते हैं, लेकिन आपको नोआम को उचित तरीके से पूर्व लिखित सूचना देनी होगी और जहां तक ​​संभव हो, प्रकटीकरण के दायरे को सीमित करने के लिए उचित प्रयास करना होगा, जिसमें हमारी सहायता करना भी शामिल है। प्रकटीकरण अनुरोधों का विरोध करने में।',
    block16:
      '(बी) सुरक्षा. आपको सेवा तक अपनी पहुंच और उपयोग को सुरक्षित रखने में मदद के लिए उचित और उचित उपाय लागू करने होंगे। यदि आपको सेवा के उपयोग से संबंधित कोई कमजोरियां या उल्लंघन पता चलता है, तो आपको तुरंत नोम से संपर्क करना होगा और भेद्यता या उल्लंघन का विवरण प्रदान करना होगा।',
    block17:
      '((सी) व्यक्तिगत डेटा का प्रसंस्करण। यदि आप व्यक्तिगत डेटा को संसाधित करने के लिए सेवा का उपयोग करते हैं, तो आपको कानूनी रूप से पर्याप्त गोपनीयता विवरण प्रदान करना होगा और ऐसे डेटा को संसाधित करने के लिए आवश्यक सहमति प्राप्त करनी होगी, और आप हमें आश्वासन देते हैं कि आप ऐसे डेटा को लागू कानून के अनुसार संभालेंगे। .',
    block18:
      '(ए) समाप्ति; निलंबन। ये शर्तें आपके द्वारा सेवा के पहले उपयोग से प्रभावी होंगी और समाप्त होने तक प्रभावी रहेंगी। आप किसी भी समय किसी भी कारण से सेवा और सामग्री का उपयोग बंद करके इन शर्तों को समाप्त कर सकते हैं। हम किसी भी कारण से पूर्व सूचना देकर इन शर्तों को समाप्त कर सकते हैं। यदि आप धारा 2 (उपयोग आवश्यकताएँ), धारा 5 (गोपनीयता, सुरक्षा और डेटा संरक्षण), धारा 8 (विवाद समाधान), या धारा 9 (सामान्य शर्तें), या यदि आप भौतिक रूप से उल्लंघन करते हैं तो हम आपको सूचित करके इन शर्तों को तुरंत समाप्त कर सकते हैं। हमारे नियंत्रण से परे किसी तीसरे पक्ष के प्रौद्योगिकी प्रदाता के साथ संबंध में परिवर्तन, या कानून या सरकारी अनुरोधों के अनुपालन के लिए। यदि आप इन शर्तों का पालन करने में विफल रहते हैं, या यदि आपका उपयोग हमारे या किसी तीसरे पक्ष के लिए सुरक्षा जोखिम पैदा करता है, या यदि हमें संदेह है कि आपका उपयोग धोखाधड़ी है या हमें या किसी तीसरे पक्ष को दायित्व के लिए उजागर कर सकता है, तो हम सेवा तक आपकी पहुंच को निलंबित कर सकते हैं। .',
    block19:
      '(बी) समाप्ति के प्रभाव. समाप्ति पर, आप सेवा का उपयोग बंद कर देंगे और हमारे निर्देशानुसार किसी भी गोपनीय जानकारी को तुरंत वापस कर देंगे या नष्ट कर देंगे। इन शर्तों के वे प्रावधान, जो अपनी प्रकृति के कारण समाप्ति या समाप्ति से बचे रहने चाहिए, जिनमें धारा 3 और 5-9 शामिल हैं, लेकिन इन्हीं तक सीमित नहीं हैं, बने रहेंगे।',
    block2:
      'उपयोग की ये शर्तें नोआम की सेवाओं के आपके उपयोग पर लागू होती हैं, जिसमें हमारे एप्लिकेशन प्रोग्रामिंग इंटरफेस, सॉफ्टवेयर, टूल, डेवलपर सेवाएं, डेटा, दस्तावेज़ीकरण और वेबसाइट (सामूहिक रूप से "सेवाएं" के रूप में संदर्भित) शामिल हैं। हमारी सेवाओं का उपयोग करके, आप इन शर्तों का पालन करने के लिए सहमत हैं। हमारी गोपनीयता नीति बताती है कि हम व्यक्तिगत जानकारी कैसे एकत्र और उपयोग करते हैं।',
    block20:
      '(ए) क्षतिपूर्ति। आप अपनी सामग्री, सेवा सहित सेवा के उपयोग से उत्पन्न होने वाले या उससे संबंधित किसी भी दावे, हानि और खर्च (वकील की फीस सहित) के खिलाफ हमारी, हमारे सहयोगियों और हमारे कर्मियों की रक्षा करेंगे, क्षतिपूर्ति करेंगे और उन्हें हानिरहित रखेंगे। सेवा से संबंधित उत्पादों या सेवाओं का उपयोग, और इन शर्तों या लागू कानून का आपका उल्लंघन।',
    block21:
      '(बी) अस्वीकरण. सेवा "जैसी है वैसी ही" प्रदान की जाती है। कानून द्वारा अनुमत सीमा तक, हम और हमारे सहयोगी और लाइसेंसकर्ता सेवा के संबंध में किसी भी प्रकार का कोई प्रतिनिधित्व या वारंटी नहीं देते हैं और कोई वारंटी नहीं देते हैं, जिसमें व्यापारिकता की वारंटी, किसी विशेष उद्देश्य के लिए उपयुक्तता, संतोषजनक गुणवत्ता, गैर-उल्लंघन शामिल है, लेकिन इन्हीं तक सीमित नहीं है। , और शांत आनंद, और व्यापार के लेन-देन या उपयोग के दौरान उत्पन्न होने वाली कोई भी वारंटी। हम इस बात की गारंटी नहीं देते हैं कि सेवा निर्बाध, सटीक, या त्रुटि-मुक्त होगी, या कोई भी सामग्री सुरक्षित होगी, खोई नहीं होगी, या बदली नहीं जाएगी।',
    block22:
      '(सी) दायित्व की सीमा. न तो हम, हमारे सहयोगी, न ही हमारे लाइसेंसकर्ता किसी भी अप्रत्यक्ष, आकस्मिक, विशेष, परिणामी, या दंडात्मक क्षति के लिए उत्तरदायी होंगे, जिसमें लाभ की हानि, प्रतिष्ठा की हानि, उपयोग की हानि, डेटा की हानि, या अन्य अमूर्त हानि शामिल है, भले ही हमें ऐसे नुकसान की संभावना के बारे में सूचित किया गया है। इन शर्तों के तहत, हमारी कुल देनदारी आपके द्वारा दावे से पहले बारह (12) महीनों में सेवा के लिए भुगतान की गई फीस या एक सौ अमेरिकी डॉलर ($100), जो भी अधिक हो, से अधिक नहीं होगी। इस अनुभाग की सीमाएँ लागू कानून द्वारा अनुमत अधिकतम सीमा तक लागू होती हैं।',
    block23:
      'अमेरिकी कानूनों के टकराव के नियमों को छोड़कर, शर्तें और सेवाओं का आपका उपयोग संयुक्त राज्य अमेरिका के कानूनों द्वारा नियंत्रित होता है। एप्लिकेशन का आपका उपयोग अन्य स्थानीय, राज्य, राष्ट्रीय या अंतर्राष्ट्रीय कानूनों के अधीन भी हो सकता है। इन शर्तों से संबंधित कोई भी कानूनी कार्रवाई या कार्यवाही विशेष रूप से संयुक्त राज्य अमेरिका की अदालतों में लाई जाएगी, और आप ऐसी अदालतों के व्यक्तिगत क्षेत्राधिकार में प्रस्तुत होने के लिए सहमत हैं।',
    block24:
      '(ए) पार्टियों का रिश्ता। नोआम और आप स्वतंत्र ठेकेदार हैं, और किसी भी पक्ष के पास दूसरे पक्ष का प्रतिनिधित्व करने या बाध्य करने या दूसरे पक्ष की पूर्व लिखित सहमति के बिना दूसरे पक्ष के लिए दायित्व ग्रहण करने की शक्ति नहीं है।',
    block25:
      '(बी) ब्रांड उपयोग। आप हमारी पूर्व लिखित सहमति के बिना नोम या उसके किसी सहयोगी के नाम, लोगो या ट्रेडमार्क का उपयोग नहीं कर सकते।',
    block26:
      'यदि इन शर्तों का कोई भी प्रावधान अमान्य, अवैध, या अप्रवर्तनीय निर्धारित किया जाता है, तो शेष प्रावधान पूरी ताकत और प्रभाव में रहेंगे।',
    block3:
      'यदि आपकी आयु 18 वर्ष से कम है, तो आपको सेवा का उपयोग करने के लिए अपने माता-पिता या कानूनी अभिभावकों से अनुमति लेनी होगी। यदि आप किसी अन्य व्यक्ति या संस्था की ओर से सेवा का उपयोग कर रहे हैं, तो आपको उनकी ओर से इन शर्तों को स्वीकार करने के लिए अधिकृत होना चाहिए। किसी खाते के लिए पंजीकरण करने के लिए आपको सटीक और संपूर्ण जानकारी प्रदान करनी होगी। आप अपने संगठन के बाहर किसी को भी अपना एक्सेस क्रेडेंशियल या खाता प्रदान नहीं कर सकते हैं, और आप अपने क्रेडेंशियल्स का उपयोग करके संचालित सभी गतिविधियों के लिए जिम्मेदार हैं।',
    block4:
      '(ए) सेवा का उपयोग। आप इन शर्तों के तहत सेवा तक पहुंच सकते हैं, और हम आपको सेवा का उपयोग करने का एक गैर-विशिष्ट अधिकार प्रदान करते हैं। सेवा का उपयोग करते समय, आप इन शर्तों और सभी लागू कानूनों का पालन करेंगे। हम और हमारे सहयोगी सेवा में सभी अधिकार, उपाधियाँ और हित रखते हैं।',
    block5:
      '(बी) प्रतिक्रिया। हम प्रतिक्रिया, टिप्पणियों, विचारों, सुझावों और सुधारों का स्वागत करते हैं। यदि आप ऐसी कोई सामग्री प्रदान करते हैं, तो हम इसे बिना किसी प्रतिबंध के और आपको मुआवजा दिए बिना उपयोग कर सकते हैं।',
    block6:
      '(सी) प्रतिबंध. आप ऐसा नहीं कर सकते: (1) सेवा का उपयोग ऐसे तरीके से करें जो दूसरों के किसी भी अधिकार का उल्लंघन, दुरुपयोग या उल्लंघन करता हो; (2) रिवर्स इंजीनियर, डिकंपाइल, डिसअसेंबल, अनुवाद, या अन्यथा स्रोत कोड या सेवा मॉडल, एल्गोरिदम और सिस्टम के अंतर्निहित घटकों की खोज करने का प्रयास (जब तक कि ऐसे प्रतिबंध लागू कानून द्वारा निषिद्ध न हों); (3) नोम के साथ प्रतिस्पर्धा करने वाले मॉडल विकसित करने के लिए सेवा के आउटपुट का उपयोग करें; (4) किसी भी स्वचालित या प्रोग्रामिंग विधियों का उपयोग करके सेवा से डेटा या आउटपुट निकालें, जब तक कि एपीआई के माध्यम से अनुमति न दी जाए, जिसमें स्क्रैपिंग, वेब हार्वेस्टिंग या वेब डेटा निष्कर्षण शामिल है; (5) सेवा के आउटपुट को कृत्रिम रूप से उत्पन्न के रूप में प्रस्तुत करना जब यह नहीं होता है, या अन्यथा हमारी उपयोग नीतियों का उल्लंघन करता है; (6) हमारी पूर्व सहमति के बिना एपीआई कुंजी खरीदना, बेचना या स्थानांतरित करना; या (7) हमें 13 वर्ष से कम उम्र के बच्चों या डिजिटल सहमति की लागू उम्र की कोई भी व्यक्तिगत जानकारी प्रदान करें। आप हमारे दस्तावेज़ में दी गई किसी भी दर सीमा और अन्य आवश्यकताओं का अनुपालन करेंगे।',
    block7:
      '(डी) तृतीय-पक्ष सेवाएँ। कोई भी तृतीय-पक्ष सॉफ़्टवेयर, सेवाएँ, या सेवा से जुड़े अन्य उत्पाद उनकी अपनी शर्तों द्वारा शासित होते हैं, और हम तृतीय-पक्ष उत्पादों के लिए ज़िम्मेदार नहीं हैं।',
    block8:
      '(ए) आपकी सामग्री। आप सेवा को इनपुट ("इनपुट") प्रदान कर सकते हैं और इनपुट (सामूहिक रूप से "सामग्री" के रूप में संदर्भित) के आधार पर उत्पन्न और लौटाए गए आउटपुट ("आउटपुट") प्राप्त कर सकते हैं। पार्टियों के बीच, और लागू कानून द्वारा अनुमत सीमा तक, आप सभी इनपुट के स्वामी हैं। नोम सेवा प्रदान करने और बनाए रखने, लागू कानूनों का अनुपालन करने और हमारी नीतियों को लागू करने के लिए सामग्री का उपयोग कर सकता है। आप सामग्री के लिए ज़िम्मेदार हैं, जिसमें यह सुनिश्चित करना भी शामिल है कि यह किसी भी लागू कानून या इन शर्तों का उल्लंघन नहीं करता है।',
    block9:
      '(बी) सटीकता. कृत्रिम बुद्धिमत्ता और मशीन लर्निंग अनुसंधान के तेजी से विकसित हो रहे क्षेत्र हैं। हम अपनी सेवा को अधिक सटीक, विश्वसनीय, सुरक्षित और लाभकारी बनाने के लिए उसमें सुधार करने का लगातार प्रयास करते हैं। मशीन लर्निंग की संभाव्य प्रकृति को देखते हुए, हमारी सेवा का उपयोग करने से कुछ मामलों में गलत आउटपुट मिल सकते हैं, जो वास्तविक व्यक्तियों, स्थानों या तथ्यों को सटीक रूप से प्रतिबिंबित नहीं कर सकते हैं। आपको अपने उपयोग के मामले के आधार पर किसी भी आउटपुट की सटीकता का उचित आकलन करना चाहिए, जिसमें आउटपुट की मैन्युअल समीक्षा भी शामिल है।',
    subTitle1: 'पंजीकरण और प्रवेश',
    subTitle10: 'विच्छेदनीयता',
    subTitle2: 'उपयोग आवश्यकताएँ',
    subTitle3: 'सामग्री',
    subTitle4: 'शुल्क और भुगतान',
    subTitle5: 'गोपनीयता, सुरक्षा और डेटा सुरक्षा',
    subTitle6: 'अवधि और समापन',
    subTitle7: 'क्षतिपूर्ति; अस्वीकरण; दायित्व की सीमा',
    subTitle8: 'शासी कानून और क्षेत्राधिकार',
    subTitle9: 'सामान्य शर्तें',
    title: 'सेवा की शर्तें',
    updateTime: 'अपडेट किया गया: 15 मार्च, 2024',
  },
  trialModal: {
    btn: 'अभी आरंभ करें（केवल $0.99）',
    chat: 'चैटपीडीएफ',
    desc1: 'आपके परीक्षण के बाद, आपसे $180 का वार्षिक शुल्क लिया जाएगा',
    desc2: 'किसी भी समय रद्द करें',
    focus: 'ध्यान केंद्रित',
    hover: 'होवर अनुवाद',
    image: 'छवि अनुवाद',
    installBtn: 'अपना उपहार प्राप्त करने के लिए अभी इंस्टॉल करें',
    memo: 'पसंदीदा प्रबंधन',
    pdf: 'पीडीएफ समानांतर अनुवाद',
    realtime: 'तुरंत अनुवाद',
    select: 'शब्द चयन अनुवाद',
    title: 'स्वागत उपहार',
    trialText: '7-दिवसीय परीक्षण',
    video: 'वीडियो अनुवाद',
    videoSummary: 'वीडियो सारांश',
    web: 'समानांतर अनुवाद',
    webSummary: 'वेब सारांश',
  },
  upgradeModal: {
    btn: 'अभी अपग्रेड करें',
    chat: {
      free: 'आप ChatPDF सीमा तक पहुंच गए हैं',
      pro: 'आप इस महीने के लिए चैटपीडीएफ सीमा तक पहुंच गए हैं',
    },
    contactStr: 'कृपया अगले रीसेट की प्रतीक्षा करें, या contact@noam.tools पर हमसे संपर्क करें।',
    limitAlertStr: 'आप अपनी निःशुल्क योजना की सीमा तक पहुँच गए हैं। जारी रखने के लिए अपग्रेड करें.',
    more: 'योजनाएं देखें',
    pageLimit: { free: 'आप पीडीएफ पेज की सीमा तक पहुंच गए हैं' },
    title: 'अनुस्मारक',
    upgradeAlertStr:
      'आप अपनी निःशुल्क योजना की सीमा तक पहुँच गए हैं। जारी रखने के लिए अपग्रेड करें.',
    upload: {
      free: 'आप अपनी पीडीएफ अनुवाद सीमा तक पहुंच गए हैं',
      pro: 'आप इस महीने के लिए अपनी पीडीएफ अनुवाद सीमा तक पहुंच गए हैं',
    },
  },
  welfare: {
    newUser: {
      joinBtn: 'अब शामिल हों',
      label: 'नए उपयोगकर्ता लाभ:',
      remain: 'केवल 30 बचे हैं',
      text: 'केवल 100 स्थान उपलब्ध! अभी अपना ले लो!',
    },
  },
}

export default TRANSLATION
